module.exports = __webpack_public_path__ + "img/shili.c540a0df.png";